<template>
  <div v-if="visible">
    <button
      type="button"
      class="version-update-badge"
      :class="{ 'version-update-badge--inline': inline }"
      title="A new version of the application is available. Please save your work and reload the page."
      aria-label="Update available. Click to reload the application."
      @click="confirmVisible = true"
    >
      <span class="version-update-dot" aria-hidden="true"></span>
      Update available
    </button>
    <DialogVue header="New version available" modal v-model:visible="confirmVisible">
      <span>
        A new version of the application is available. Please save your work and reload the page.
      </span>
      <template #footer>
        <ui-button label="Cancel" variant="secondary" @click="confirmVisible = false"></ui-button>
        <ui-button label="Reload" @click="$emit('reload')"></ui-button>
      </template>
    </DialogVue>
  </div>
</template>

<script>
export default {
  name: "VersionUpdateBadge",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // Renders in the page flow (header bar) instead of floating bottom-right
    inline: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["reload"],
  data() {
    return {
      confirmVisible: false,
    };
  },
};
</script>

<style scoped>
.version-update-badge {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 10000;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 1px solid #2d6e6d;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  font-family: "Voyado Text", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #2d6e6d;
  cursor: pointer;
}

.version-update-badge:hover,
.version-update-badge:focus-visible {
  background: #edf8f4;
}

.version-update-badge--inline {
  position: static;
  margin-right: 10px;
  padding: 4px 12px;
  font-size: 13px;
  box-shadow: none;
}

.version-update-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2d6e6d;
}
</style>
